import React from 'react'
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom'
import { AuthProvider } from './hooks/useAuth'
import Home from './pages/Home'
import TourSearchPage from './pages/TourSearchPage'
import HotTours from './pages/HotToursPage'
import MinPrices from './pages/MinPricesPage'
import Countries from './pages/CountriesPage'
import ChinaTours from './pages/ChinaToursPage'
import Cruises from './pages/CruisesPage'
import CruiseDetailPage from './pages/CruiseDetailPage'
import About from './pages/AboutPage'
import Contacts from './pages/ContactsPage'
import AdminRoutes from './admin'
import TelegramBotWidget from './components/TelegramBotWidget'
import './styles/main.css'

function AppContent() {
  const location = useLocation()
  const isAdminRoute = location.pathname.startsWith('/admin')

  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/podbor-tyra" element={<TourSearchPage />} />
        <Route path="/goryashchie-tury" element={<HotTours />} />
        <Route path="/minimalnye-tseny" element={<MinPrices />} />
        <Route path="/strany" element={<Countries />} />
        <Route path="/china" element={<ChinaTours />} />
        <Route path="/cruises" element={<Cruises />} />
        <Route path="/cruises/:slug" element={<CruiseDetailPage />} />
        <Route path="/o-nas" element={<About />} />
        <Route path="/kontakty" element={<Contacts />} />
        <Route path="/admin/*" element={<AdminRoutes />} />
      </Routes>
      
      {/* Показываем виджет только не на админских страницах */}
      {!isAdminRoute && <TelegramBotWidget />}
    </div>
  )
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <AppContent />
      </Router>
    </AuthProvider>
  )
}

export default App